import { useFormik } from 'formik'
import React from 'react'
import toast from 'react-hot-toast'
import * as Yup from 'yup'
import { FaCheckCircle } from 'react-icons/fa'
import { useDisable2FAMutation } from '../../../features/2fa/twoFactorSlice'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectCurrentToken,
  selectCurrentUser,
  selectRefreshToken,
  setCredentials,
} from '../../../features/auth/authSlice'

export const Disable2FAForm = () => {
  const dispatch = useDispatch()

  const token = useSelector(selectCurrentToken)
  const user = useSelector(selectCurrentUser)
  const refreshToken = useSelector(selectRefreshToken)

  const [disable2FA, { isLoading }] = useDisable2FAMutation()

  const formik = useFormik({
    initialValues: {
      code: null,
    },
    validationSchema: Yup.object().shape({
      code: Yup.number().required('Provide the code to verify'),
    }),
    onSubmit: async (values) => {
      try {
        toast.loading('Trying to disable two factor authentication...')
        await disable2FA({ code: values.code }).unwrap()
        toast.dismiss()
        formik.resetForm()
        // user object modification
        const newUser = { ...user, is2FAEnabled: false }
        dispatch(setCredentials({ user: newUser, token, refreshToken }))
        toast.success('Two factor authentication is disabled!')
      } catch (error: any) {
        toast.dismiss()
        console.log(error?.data.message)
        toast.error(error?.data.message)
      }
    },
  })
  return (
    <div className='flex flex-col items-center gap-8'>
      <div className='flex flex-col items-center gap-6'>
        <FaCheckCircle className='text-green-500 text-5xl' />
        <p className='text-white/80 text-base md:text-lg text-center'>
          Two Factor Authentication is enabled!
        </p>
      </div>

      <form
        className='flex flex-col gap-2 mt-4 w-full max-w-sm'
        onSubmit={formik.handleSubmit}
      >
        <label htmlFor='code' className='text-xs text-white/70'>
          Type the 2FA code below to disable Two Factor Authentication
        </label>
        <input
          type='number'
          name='code'
          id='code'
          placeholder=''
          value={formik.values.code || ''}
          onChange={formik.handleChange}
          className='form-input spin-button-none '
        />

        <p className='text-red-500 text-xs'>
          {formik.touched.code &&
            Boolean(formik.errors.code) &&
            formik.errors.code}
        </p>
        <button
          type='submit'
          className='btn-primary px-4 py-2 rounded-md w-full max-w-sm'
        >
          Disable
        </button>
      </form>
    </div>
  )
}
